import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import local from '../../../assets/food/localcuisine.webp';
// import northindian from '../../../assets/food/north-indian.webp';
// import konkani from '../../../assets/food/konkan.webp';
// import labiation from '../../../assets/food/drinks.webp';
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import './Exquisite.css'

function Exquisite() {
  return (
    <section className="food px-md-5 px-3 pt-5" id='Exquisite'>
      <Row className='pb-5 px-md-5 px-3 food-row'>
          <Col md={5} className = " d-flex flex-column align-items-start justify-content-center">
          <h3 className="section-heading pt-5  pb-3 text-start">
          Local Cuisine 
    </h3>
    <p className='text-white'>
    Sindhudurg cuisine, rooted in the coastal region of Maharashtra, is a flavorful
blend of traditional Konkan and Malvani cooking styles. Known for its use of
fresh, locally sourced ingredients, the cuisine prominently features coconut,
rice, seafood, and an array of spices. Coconut milk, grated coconut, and kokum (a
sour fruit) are key components, adding richness and tang to the dishes.
    </p>
    <p className='text-white'>
    Seafood, particularly fish like mackerel, pomfret, and prawns, is a staple, with dishes
like malvani fish curry, prawns sukkha, and bangda fry being local favorites.
Vegetarians can enjoy a variety of dishes such as sol kadhi (a refreshing kokum and
coconut milk drink), ghavne (rice pancakes), and ukdiche modak (steamed sweet
dumplings). The cuisine is known for its balanced flavors of spicy, tangy, and mildly
sweet elements, making it a unique culinary experience.
    </p>
    <div  class="food-btn d-block ">
                <Link to="/food"> 
               See More
                </Link>
            </div>
          </Col>
          <Col md={7} className='food-img'>
          <img src={local} alt='local cuisine' className='img-fluid' loading='lazy'/>
          </Col>
      </Row>
      </section> 
  
  )
}

export default Exquisite
